<app-section-quick-actions section="item" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Items</h1>
  <div class="atmos-items__actions">
    <div class="atmos-items__count"aria-live="polite">
      <strong>{{ unlockedCount() }}</strong>
      <span class="atmos-items__count-sep"> / {{ totalCount() }}</span>
      <span class="atmos-items__count-label"> unlocked</span>
    </div>
  </div>
</header>

<div class="atmos-card atmos-items__grid-card">
  <ag-grid-angular [rowData]="rowData()" [columnDefs]="colDefs" [theme]="theme"
    [getRowHeight]="getRowHeight" [suppressDragLeaveHidesColumns]="true"
    (gridReady)="onGridReady($event)" (firstDataRendered)="onFirstDataRendered()" />
</div>
